import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {toast} from "react-toastify";
import { fetchDocuments } from "./documentsAPI";
import { catchAllErrors } from "../../hoc/catchAllErrors";

export const fetchDocumentsAsync = createAsyncThunk("documents/fetchDocuments", async (userId) => {
    try {
        const response = await catchAllErrors(fetchDocuments)(userId);
        return response;
    } catch (error) {
        toast("Failed to fetch documents", { type: "error" });
        throw error;
    }
});

export const documentsSlice = createSlice({
    name: "documents",
    initialState: {
        documents: null,
        document: null,
        meta: {},
        status: "idle",
        error: null,
    },
    reducers: {
        setDocuments: (state, action) => {
            state.documents = action.payload;
        },
        setDocument: (state, action) => {
            state.document = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDocumentsAsync.pending, (state) => {
                state.documents = [];
                state.status = "pending";
            })
            .addCase(fetchDocumentsAsync.fulfilled, (state, action) => {
                state.documents = action.payload;
                state.status = "fulfilled";
            })
            .addCase(fetchDocumentsAsync.rejected, (state, action) => {
                state.documents = [];
                state.status = "rejected";
                state.error = action.error.message;
            })
    },
});

export const { setDocuments, setDocument } = documentsSlice.actions;

export const selectDocuments = (state) => state.documents.documents;

export const selectDocument = (state) => state.documents.document;

export default documentsSlice.reducer;
